import { jwtDecode } from 'jwt-decode';

import { AccessTokenClaims } from './types';

/**
 * Decode the access token and return the claims
 * @param token - The access token
 * @returns The claims of the access token
 */
function decodeAccessToken(token: string | undefined): AccessTokenClaims {
  if (!token) return { wrt: false };
  try {
    return jwtDecode<AccessTokenClaims>(token);
  } catch (error) {
    console.error('Error decoding access token', error);
    return { wrt: false };
  }
}

/**
 * Check if the user is view-only
 * @param token - The access token
 * @returns True if the user is view-only, false otherwise
 */
export function tokenIsViewOnly(token: string | undefined): boolean {
  const { wrt } = decodeAccessToken(token);
  return wrt !== true;
}
